import axios from 'axios'
import store from '@/store/store'
import Vue from 'vue'
var VueCookie = require('vue-cookie')

const getQueryParameter = (name) => {
  const searchValue = new URLSearchParams(location.search).get(name)
  if (searchValue) {
    return searchValue
  }

  const hashQueryIndex = location.hash.indexOf('?')
  if (hashQueryIndex === -1) {
    return null
  }

  return new URLSearchParams(location.hash.slice(hashQueryIndex + 1)).get(name)
}

const token = VueCookie.get('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}



export default () => {
  var headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }

  var api = axios.create({
    baseURL: process.env.API,
    headers: headers
  })

  var token = VueCookie.get("token")
  if (!token) {
    token = getQueryParameter("token")
  }

  let customer = getQueryParameter("customer")

  api.interceptors.request.use(
    config => {
      if (token) {
        config.headers.Authorization = token;
      }
      if (customer) {
        config.headers.Customer = customer;
      }
      return config
    },
    error => Promise.reject(error)
  );

  api.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    let message = null;

    if (error.response && [401, 403].includes(error.response.status)) {
      store.commit("LOGOUT")
    }
    if (error.message) {
      Vue.toasted.show(message, {
        duration: null,
        theme: "bubble",
        iconPack: "fontawesome",
        type: "error",
        fullWidth: true,
        icon: "exclamation-triangle",
        action: {
          text: 'Chiudi',
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          }
        },
      });
    }

    return Promise.reject(error);
  });

  return api
}



// WEBPACK FOOTER //
// ./src/services/api.js